export default __webpack_public_path__ + "static/media/Clothing.588e8441.webp";